// src/auth/ProtectedRoute.tsx
// Updated: 2026-08-20 15:00:00 CDT
// Purpose: Wrap protected routes. If there's no authenticated user, redirect to /login
// and remember where the user tried to go. Includes verbose logging.

import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";

const ProtectedRoute: React.FC = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // eslint-disable-next-line no-console
    console.debug("[ProtectedRoute] Waiting for auth to resolve…", { pathname: location.pathname });
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <div className="text-sm text-gray-500">Checking authentication…</div>
      </div>
    );
  }

  if (!user) {
    // eslint-disable-next-line no-console
    console.warn("[ProtectedRoute] No user. Redirecting to /login from:", location.pathname);
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // eslint-disable-next-line no-console
  console.debug("[ProtectedRoute] Authenticated. Rendering protected content:", location.pathname);
  return <Outlet />;
};

export default ProtectedRoute;
